

































































































































































import CollapseTransition from '@/components/collapseTransition/collapseTransition'; // 导入过渡函数
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { Component, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { performanceServer } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';
import ViewDialog from '@/views/responsibility/unit/viewDialog.vue';
import AddInventoryDialog from '@/views/inventoryManagement/unit/addInventoryDialog.vue';
import EditInventoryDialog from '@/views/inventoryManagement/unit/editInventoryDialog.vue';
import GenerateTaskDialog from '@/views/inventoryManagement/unit/generateTaskDialog.vue';
import ViewInventoryDetails from '@/views/inventoryManagement/unit/viewInventoryDetails.vue';
import BatchDialogData from '@/views/inventoryManagement/unit/batchDialogData.vue';

@Component({
  components: {
    ViewInventoryDetails,
    GenerateTaskDialog,
    EditInventoryDialog,
    AddInventoryDialog,
    ViewDialog,
    CollapseTransition,
    PagingUnit,
    BatchDialogData,
  },
  mixins: [TableStripe],
})
export default class PerformanceManagement extends Vue {
  // 查询分页表单
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  // 控制列表删除按钮
  total = 0; // 总共多少条数据
  pageIndex = 1; // 总共多少条数据
  private editData: any = {}; //选中的单挑编辑项
  private NewType: any = ''; //选中的单挑编辑项
  obj: object = {}; // 搜索需要的对象
  // 表单数据对象
  formData: any = {
    executeDepartmentIdAndSub: '',
    executePostId: '',
    executeStaffId: '',
    search: '',
    frequency: '',
    frequencyUnit: '',
    createTask: null,
  };
  // table 数据对象
  tableData: any = [];

  // 执行部门
  subSpaceByAuthOptions: any = [];
  // 职务
  spacePostByAuthOptions: any = [];
  // 人员
  spaceStaffByAuthOptions: any = [];
  multipleSelection: any = [];

  created() {
    // 获取分页数据
    this.getSubSpaceByAuth();
    this.getPageData();
  }

  viewTaskInfo(data: any) {
    const viewDialog: any = 'viewDialog';
    const viewDialogRef: any = this.$refs[viewDialog];
    viewDialogRef.showDialog(data);
  }

  // 新增 、 编辑
  createExam(type: any, data?: any) {
    switch (type) {
      case 'add':
        this.pageIndex = 2;
        this.NewType = type;
        break;
      case 'edit':
        this.pageIndex = 3;
        this.NewType = type;
        this.editData = data;
        break;
    }
  }

  // 生成任务
  generateTask(data?: any) {
    const generateDialog: any = 'generateDialog';
    const generateDialogRef: any = this.$refs[generateDialog];
    generateDialogRef.showAddDialog(data);
  }

  // 打开删除事件
  openDeletedialog(id: any) {
    this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.deleteRiskControlInventory(id);
        this.getPageData();
      })
      .catch(() => {
        this.$message.info('已取消删除');
      });
  }

  // 删除
  private deleteRiskControlInventory(newId: any) {
    performanceServer.deleteDutyRuleList(newId).then((res: any) => {
      if (res.code === '200') {
        this.$message.success('删除成功');
        this.getPageData();
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  // 查看
  viewManagement(data: any) {
    this.pageIndex = 4;
    this.editData = data;
  }

  // 部门筛选： 岗位 / 人员
  getChangePost(e: any) {
    this.formData.executePostId = '';
    this.formData.executeStaffId = '';
    if (e) {
      this.getSpacePostByAuth(e);
      this.getSpaceStaffByAuth(e);
    } else {
      this.spacePostByAuthOptions = [];
      this.spaceStaffByAuthOptions = [];
    }
  }

  /**
   * @desc 获取所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getPageData() {
    this.pageIndex = 1;
    // 发起接口请求，获取分页数据
    performanceServer
      .getDutyRuleList({
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
        executeDepartmentIdAndSub: this.formData.executeDepartmentIdAndSub ? this.formData.executeDepartmentIdAndSub : null,
        executePostId: this.formData.executePostId ? this.formData.executePostId : null,
        executeStaffId: this.formData.executeStaffId !== '' ? this.formData.executeStaffId : null,
        search: this.formData.search ? this.formData.search : null,
        frequency: this.formData.frequency ? Number(this.formData.frequency) : null,
        frequencyUnit: this.formData.frequencyUnit ? this.formData.frequencyUnit : null,
        createTask: this.formData.createTask,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    const userInfo: any = localStorage.getItem('userInfo');
    const userInfoObj: any = JSON.parse(userInfo);
    this.formData.executeDepartmentIdAndSub = userInfoObj.topDeptId;
    this.getSpacePostByAuth(userInfoObj.topDeptId);
    this.getSpaceStaffByAuth(userInfoObj.topDeptId);
    // 发起接口请求，获取分页数据
    performanceServer
      .getSubSpaceByAuth({
        topId: userInfoObj.topDeptId,
      })
      .then((res: any) => {
        this.subSpaceByAuthOptions = arrayToTree(res.data);
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取职务数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpacePostByAuth(id: any) {
    // 发起接口请求，获取分页数据
    performanceServer
      .getSpacePostByAuth({ deptId: id })
      .then((res: any) => {
        this.spacePostByAuthOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 获取人员数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpaceStaffByAuth(id: any) {
    // 发起接口请求，获取分页数据
    performanceServer
      .getSpaceStaffByAuth({ deptId: id })
      .then((res: any) => {
        this.spaceStaffByAuthOptions = res.data;
      })
      .catch((error: any) => {
        this.$message.error('获取数据失败');
      });
  }

  /**
   * @desc 点击分页按钮触发，改变内容
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    // 调用获取分页数据
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  search() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.getPageData();
  }

  /**
   * @desc 点击查询按钮触发，查询符合条件的内容.
   * @param1 暂无
   * @returns 暂无
   */
  resetFormData() {
    (this.queryDataForm as any).pageNo = 1;
    (this.queryDataForm as any).pageSize = 10;
    this.formData = {
      executeDepartmentIdAndSub: this.formData.executeDepartmentIdAndSub,
      executePostId: '',
      executeStaffId: '',
      search: '',
    };
    this.getPageData();
  }
  /**
   * 表格选中的变化
   */
  handleSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  batchCreateTask() {
    if (!this.multipleSelection.length) {
      this.$message.warning('请选择需要生成任务的数据');
      return;
    } else {
      const containCreateData: any = this.multipleSelection.some((item: any) => item.createTask);
      if (containCreateData) {
        this.$message.warning('所选数据中包含已创建的任务，请选择未创建的任务');
        return;
      } else {
        const selectedDataIds: any = this.multipleSelection.map((item: any) => {
          return item.id;
        });
        const BatchDialogDataDataComponent: any = this.$refs['BatchDialogData'];
        BatchDialogDataDataComponent.showDialog(selectedDataIds);
      }
    }
  }
}
